"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

require("./Icon.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Icon(_ref) {
  var type = _ref.type,
      size = _ref.size,
      className = _ref.className,
      margin = _ref.margin,
      color = _ref.color;
  var cssClasses = ['st_icon', "st_icon--" + size];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addMarginClasses(margin, cssClasses);
  if (color) cssClasses.push("st_icon--color-" + color);
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    className: cssClasses.join(' ')
  }, /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#icon-" + type
  }));
}

Icon.propTypes = {
  /** size of icon */
  size: _propTypes["default"].oneOf(['sm', 'smd', 'md', 'mlg', 'lg']),

  /** type of icon */
  type: _propTypes["default"].string.isRequired,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for icon, if any */
  margin: utils.spacing.marginProps,

  /** color, if not inheriting from parent's text color */
  color: _propTypes["default"].oneOf(['ink', 'blurple', 'asphalt', 'lava', 'emerald', 'white'])
};
Icon.defaultProps = {
  size: 'md',
  className: '',
  margin: null,
  color: null
};
var _default = Icon;
exports["default"] = _default;